import { FC } from "react";

import { Stack } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

import { NewsletterFormSignupData } from "../types";

import { isNameValid, isRequired } from "@/common/helpers/validators";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardTextField } from "@/dashboard-design-system/TextField/DashboardTextField";

type NewsletterFormNameFieldsProps = {
  form: UseFormReturn<NewsletterFormSignupData>;
  hasFirstName?: boolean;
  hasLastName?: boolean;
  previewConfiguration?: {
    isPreview: boolean;
  };
};

export const NewsletterFormNameFields: FC<NewsletterFormNameFieldsProps> = ({ form, hasFirstName, hasLastName }) => {
  const { t } = useTranslate();
  const { errors } = form.formState;

  return (
    <Stack direction="row" gap={1}>
      {hasFirstName && (
        <DashboardTextField
          name="firstName"
          data-test="form-firstname"
          control={form.control}
          placeholder={t("dashboard", "newsletterForms.editor.step.questions.field.firstName")}
          rules={[isRequired(t("common", "firstName.required")), isNameValid(t("common", "invalidCharacterUsed"))]}
          errorMessage={errors.firstName?.message}
          disableAutocomplete
        />
      )}
      {hasLastName && (
        <DashboardTextField
          name="lastName"
          data-test="form-lastname"
          control={form.control}
          placeholder={t("dashboard", "newsletterForms.editor.step.questions.field.lastName")}
          rules={[isRequired(t("common", "lastName.required")), isNameValid(t("common", "invalidCharacterUsed"))]}
          errorMessage={errors.lastName?.message}
          disableAutocomplete
        />
      )}
    </Stack>
  );
};
